import { Component } from 'react';
import classNames from 'classnames/bind';
import { Dropdown } from 'react-bootstrap';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';

import withComponentName from '../../../../../../../decorators/withComponentName';

import Styles from '../styles.module.scss';

const cx = classNames.bind(Styles);

class YearDropdown extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      scrollTop: 0,
      scrollHeight: 0,
      clientHeight: 0,
      isTop: '',
      isBottom: 'block',
    };

    autoBind(this);
  }

  componentDidUpdate(_, prevState) {
    const { scrollTop, scrollHeight, clientHeight } = this.state;
    if (prevState.scrollTop === scrollTop && prevState.scrollHeight === scrollHeight
      && prevState.clientHeight === clientHeight) return;

    const isBottom = clientHeight === scrollHeight - scrollTop;
    const isTop = scrollTop === 0;
    const isBetween = scrollTop > 0 && clientHeight < scrollHeight - scrollTop;

    let top = 'none';
    let bottom = 'none';

    if (isTop) {
      bottom = 'block';
    } else if (isBetween) {
      bottom = 'block';
      top = 'block';
    } else if (isBottom) {
      top = 'block';
    }

    this.setState({
      isTop: top,
      isBottom: bottom,
    });
  }

  handleSelect(value) {
    const { type, handleOptionSelect } = this.props;
    handleOptionSelect(value, type);
    this.setState({
      isOpen: false,
    });
  }

  onScrollHandler(event) {
    this.setState({
      scrollTop: event.target.scrollTop,
      scrollHeight: event.target.scrollHeight,
      clientHeight: event.target.clientHeight,
    });
  }

  toggleDropdown(status, event, source) {
    if (
      status === false
      && source.source === 'select'
    ) {
      return;
    }

    this.setState({
      isOpen: status,
    });
  }

  render() {
    const {
      type, options, selectedValue, isSelectAll, maxValue, minValue,
    } = this.props;
    const { isOpen, isTop, isBottom } = this.state;

    return (
      <div className={cx('year_dropdown', { disable: isSelectAll })}>
        <div className={Styles.year_text}>{type}</div>
        <div className={Styles.year_dropdown_holder}>
          <Dropdown
            show={isOpen}
            onToggle={this.toggleDropdown}
          >
            <Dropdown.Toggle>
              <div className={Styles.header_btn}>
                <div className={Styles.header_holder}>
                  <div className={Styles.main_header}>{selectedValue}</div>
                </div>
                <div className={Styles.header_icon}>
                  <FontAwesomeIcon icon={isOpen ? faChevronUp : faChevronDown} />
                </div>
              </div>
            </Dropdown.Toggle>
            <Dropdown.Menu flip={false}>
              <div onScroll={this.onScrollHandler} className={Styles.year_options}>
                <div style={{ display: isTop }} className={Styles.top_gradient} />
                <div style={{ display: isBottom }} className={Styles.bottom_gradient} />
                {
                  options.map(({ id, title, value }) => (
                    <OptionRow
                      key={id}
                      name={title}
                      value={value}
                      selectedValue={selectedValue}
                      onSelect={this.handleSelect}
                      type={type}
                      maxValue={maxValue}
                      minValue={minValue}
                    />
                  ))
                }
              </div>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
    );
  }
}

const OptionRow = ({
  name, value, selectedValue, onSelect, type, maxValue, minValue,
}) => {
  const isDisabled = type === 'from' ? value > maxValue : value < minValue;

  return (
    <Dropdown.Item
      eventKey={value}
      active={(selectedValue || '').toString() === value.toString()}
      onSelect={onSelect}
      disabled={isDisabled}
    >
      <div className={Styles.row_value}>{name}</div>
    </Dropdown.Item>
  );
};

export default withComponentName(YearDropdown);
